import { withStyles } from "@material-ui/styles";
import CroppingForm from "Forms/CroppingForm";
import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { compose } from "redux";
import ProfileActions, { ProfileSelectors } from "Redux/ProfileRedux";
import ProjectActions from "Redux/ProjectRedux";
import { Fonts } from "Themes/Fonts";
import { MainContainerTheme } from "Themes/Metrics";
import styles from "./styles";

class CroppingScreen extends Component {
  state = {
    show: false,
    success: false,
    error: null,
    fetching: false
  };

  componentDidUpdate(prevProps) {
    if (this.props.profile !== prevProps.profile) {
      this.setState({
        show: true
      });
    }
  }

  onConfirm = () => {
    this.props.history.push("/Settings");
  };

  handleSubmit = val => {
    const {
      updateAvatar,
      location: { state }
    } = this.props;

    this.setState({ fetching: true });
    if (state.type === "project") {
      const resolve = {
        onSuccess: () =>
          this.setState({
            error: null,
            fetching: false,
            success: true
          }),
        onFailure: () =>
          this.setState({
            error: true,
            fetching: false,
            success: false
          })
      };
      const data = {
        id: state.id,
        image: val
      };
      // Update project
      this.props.addProjectImage(data, resolve);
    }

    if (state.type === "project-avatar") {
      updateAvatar(val);
    }
  };

  render() {
    const { location } = this.props;
    const { show } = this.state;
    return (
      <MainContainerTheme>
        <h1 style={Fonts.headerFont}>Crop your image</h1>
        <CroppingForm
          img={location.state.detail}
          handleSubmit={this.handleSubmit}
        />
        <SweetAlert
          success
          title="Profile Picture updated!"
          onConfirm={this.onConfirm}
          show={show}
        />
      </MainContainerTheme>
    );
  }
}

const mapStateToProps = state => {
  return {
    profile: ProfileSelectors.getProfile(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateAvatar: data => dispatch(ProfileActions.updateAvatarRequest(data)),
    addProjectImage: (data, resolve) =>
      dispatch(ProjectActions.addProjectImageRequest(data, resolve))
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  withStyles(styles),
  withRedux
)(CroppingScreen);
